import { zodResolver } from '@hookform/resolvers/zod';
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { z as zod } from 'zod';
import Grid from '@mui/material/Unstable_Grid2';
import { useEffect, useState } from 'react';
import { readTitlePoolId } from '@/api/asset/pool/read';
import Header from '@/component/Header';
import { addUserReward } from '@/api/asset/pool/create';
import { toast } from 'react-toastify';

const schema = zod.object({
  poolId: zod.string().min(1, { message: '필수 입력' }),
  joinId: zod.string().min(1, { message: '필수 입력' }),
  address: zod.string().min(1, { message: '필수 입력' }),
  rewardAmt: zod.string().min(1, { message: '필수 입력' }),
  rewardHash: zod.string().min(1, { message: '필수 입력' }),
  rewardDt: zod.string().min(1, { message: '2024-11-12 18:10:37 형태로 입력' }),
  rewardUsdt: zod.string().min(1, { message: '필수 입력' }),
});

type Values = zod.infer<typeof schema>;
const defaultValues = {
  poolId: '',
  joinId: '',
  address: '',
  rewardAmt: '',
  rewardHash: '',
  rewardDt: '',
  rewardUsdt: '',
} satisfies Values;

export default function AddUserReward() {
  const [, setList] = useState<{ address: string; poolId: string }[] | null>(null);
  useEffect(() => {
    (async () => {
      const re = await readTitlePoolId();
      console.log(re);
      setList(re.data);
    })();
    return () => {};
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  const onSubmit = async (data: Values) => {
    console.log(data);

    const re = await addUserReward(data);

    // const re = await createAddress(data);
    if (re.status !== 200) {
      return;
    }
    toast.success('성공');
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Header title="사용자 예상" />
        <Divider />
        <CardContent
          sx={{
            flex: 1, // CardContent가 나머지 공간을 차지하도록 설정
            overflow: 'auto', // 스크롤을 가능하게 함
          }}
        >
          pool_id, join_id는 User-Dashboard에서 address 검색 후 Stake 리스트에서 확인 가능 <br />
          풀(pool_id)에 여러 번 스테이킹을 했을 경우 join_id는 스테이킹 만큼 나온다. <br />
          <br />※ Pool-List - Detail에서 컨트랙트 주소와 reward_hash 주소 비교 필수
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              <Grid md={6} xs={12}>
                <Controller
                  control={control}
                  name="poolId"
                  render={({ field }) => (
                    <FormControl fullWidth required>
                      <InputLabel>pool_id</InputLabel>
                      <OutlinedInput {...field} label="poolId" type="text" fullWidth />
                      {errors.poolId && <FormHelperText>{errors.poolId.message}</FormHelperText>}
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid md={6} xs={12}>
                <Controller
                  control={control}
                  name="joinId"
                  render={({ field }) => (
                    <FormControl fullWidth required>
                      <InputLabel>join_id</InputLabel>
                      <OutlinedInput {...field} label="joinId" type="text" fullWidth />
                      {errors.joinId && <FormHelperText>{errors.joinId.message}</FormHelperText>}
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid xs={12}>
                <Controller
                  control={control}
                  name="address"
                  render={({ field }) => (
                    <FormControl error={Boolean(errors.address)} fullWidth required>
                      <InputLabel>address</InputLabel>
                      <OutlinedInput {...field} label="address" type="text" fullWidth />
                      {errors.address ? <FormHelperText>{errors.address.message}</FormHelperText> : null}
                    </FormControl>
                  )}
                />
              </Grid>

              <Grid xs={12}>
                <Controller
                  control={control}
                  name="rewardHash"
                  render={({ field }) => (
                    <FormControl error={Boolean(errors.rewardHash)} fullWidth required>
                      <InputLabel>reward_hash</InputLabel>
                      <OutlinedInput {...field} label="rewardHash" type="text" fullWidth />
                    </FormControl>
                  )}
                />
              </Grid>

              <Grid md={6} xs={12}>
                <Controller
                  control={control}
                  name="rewardAmt"
                  render={({ field }) => (
                    <FormControl error={Boolean(errors.rewardAmt)} fullWidth required>
                      <InputLabel>reward_amt</InputLabel>
                      <OutlinedInput {...field} label="rewardAmt" type="text" />
                    </FormControl>
                  )}
                />
              </Grid>

              <Grid md={6} xs={12}>
                <Controller
                  control={control}
                  name="rewardUsdt"
                  render={({ field }) => (
                    <FormControl error={Boolean(errors.rewardUsdt)} fullWidth required>
                      <InputLabel>reward_usdt</InputLabel>
                      <OutlinedInput {...field} label="rewardUsdt" type="text" />
                    </FormControl>
                  )}
                />
              </Grid>

              <Grid md={6} xs={12}>
                <Controller
                  control={control}
                  name="rewardDt"
                  render={({ field }) => (
                    <FormControl error={Boolean(errors.rewardDt)} fullWidth required>
                      <InputLabel>reg_dt</InputLabel>
                      <OutlinedInput {...field} label="red_dt" type="text" />
                      <FormHelperText>※ex: 2024-11-12 18:10:37 </FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>

              <Grid xs={12}>
                <Button variant="contained" type="submit" fullWidth>
                  생성
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
